import Vue from 'vue'
import { changeUser, login, loginYs, logout, phoneLogin, thirdLogin } from '@/api/login'
import {
  ACCESS_TOKEN,
  CURR_GRADECLASS,
  IDENTITY_ID,
  SYS_BUTTON_AUTH,
  TENANT_AREA_INFO,
  TENANT_ID,
  UI_CACHE_DB_DICT_DATA,
  USER_AUTH,
  USER_AUTH_MENU,
  USER_INFO,
  USER_NAME,
} from '@/store/mutation-types'
import { timeFix, welcome } from '@/utils/util'
import { queryPermissionsByUser } from '@/api/api'
import { getAction } from '@/api/manage'
import { resetRouter } from '@/router'
import { Modal, notification } from 'ant-design-vue'

const user = {
  state: {
    token: '',
    username: '',
    realname: '',
    tenantid: '',
    identityId: '',
    welcome: '',
    avatar: '',
    permissionList: [],
    info: {},
    currGradeClass: {},
    tenantAreaInfo: {},
    currUserActionAuth: [], // 当前用户操作权限
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { username, realname, welcome }) => {
      state.username = username
      state.realname = realname
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONLIST: (state, permissionList) => {
      state.permissionList = permissionList
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_TENANT: (state, id) => {
      state.tenantid = id
    },
    SET_IDENTITY: (state, id) => {
      state.identityId = id
    },
    SET_CURRGRADECLASS: (state, info) => {
      state.currGradeClass = info
    },
    SET_TENANTAREAINFO: (state, info) => {
      state.tenantAreaInfo = info
      Vue.ls.set(TENANT_AREA_INFO, info, 7 * 24 * 60 * 60 * 1000)
    },
    SET_CURRUSERACTIONAUTH: (state, info) => {
      state.currUserActionAuth = info
    },
  },

  actions: {
    // CAS验证登录
    ValidateLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        getAction('/cas/client/validateLogin', userInfo)
          .then((response) => {
            console.log('----cas 登录--------', response)
            if (response.success) {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)
              resolve(response)
            } else {
              resolve(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取身份对应的年级班级：请求成功/失败都不阻断后续操作，是否刷新由 isReload 决定
    async getCurrGradeClass({ commit }, { userIdentitys, isReload = false }) {
      try {
        if (userIdentitys && userIdentitys.length) {
          const res = await getAction('/aigoes/schoolClass/getGradeClassByUserIdentity', {
            userIdentity: Number(userIdentitys[0]),
          })
          if (res && res.success) {
            console.log('年级班级信息：', res)
            Vue.ls.set(CURR_GRADECLASS, res.result, 7 * 24 * 60 * 60 * 1000)
            commit('SET_CURRGRADECLASS', res.result)
            return res.result
          }
        }
      } catch (error) {
        console.warn('getGradeClassByUserIdentity 请求失败，跳过年级班级获取：', error)
      } finally {
        // 刷新放在 finally：无论请求成功、失败还是接口报错，都按 isReload 执行
        if (isReload) {
          location.reload()
        }
      }
    },
    // 获取租户对应的地区LOGO和标题：接口报错（500 等）不阻断后续操作
    async getTenantIdData({ commit }) {
      try {
        const res = await getAction('/ddUser/getTenantIdData')
        if (res && res.success) {
          commit('SET_TENANTAREAINFO', res.result)
        }
      } catch (error) {
        console.warn('getTenantIdData 请求失败，跳过租户地区信息获取：', error)
      }
    },
    // 登录
    Login({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((response) => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)
              console.log(userInfo)
              var tenendIds = userInfo.relTenantIds
              console.log('tenendIds', tenendIds)
              var tenendId = !tenendIds || tenendIds.length === 0 ? 0 : tenendIds.split(',')[0]

              Vue.ls.set(TENANT_ID, tenendId, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TENANT', tenendId)

              dispatch('getTenantIdData')

              const userIdentitys = userInfo.userIdentity.split(',')
              Vue.ls.set(IDENTITY_ID, userIdentitys[0], 7 * 24 * 60 * 60 * 1000)
              commit('SET_IDENTITY', userIdentitys[0])
              dispatch('getCurrGradeClass', { userIdentitys })
              if (userIdentitys.includes('20')) {
                Vue.ls.set('devOps', true, 7 * 24 * 60 * 60 * 1000)
              }
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 自动登录
    AutoLogin({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        loginYs(userInfo)
          .then((response) => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)
              var tenendIds = userInfo.relTenantIds
              var tenendId = !tenendIds || tenendIds.length === 0 ? 0 : tenendIds.split(',')[0]

              Vue.ls.set(TENANT_ID, tenendId, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TENANT', tenendId)

              dispatch('getTenantIdData')

              const userIdentitys = userInfo.userIdentity.split(',')
              Vue.ls.set(IDENTITY_ID, userIdentitys[0], 7 * 24 * 60 * 60 * 1000)
              commit('SET_IDENTITY', userIdentitys[0])
              dispatch('getCurrGradeClass', { userIdentitys })
              if (userIdentitys.includes('20')) {
                Vue.ls.set('devOps', true, 7 * 24 * 60 * 60 * 1000)
              }
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    //手机号登录
    PhoneLogin({ commit, dispatch }, userInfo) {
      return new Promise((resolve, reject) => {
        phoneLogin(userInfo)
          .then((response) => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)

              console.log(userInfo)
              var tenendIds = userInfo.relTenantIds
              console.log(tenendIds)
              var tenendId = !tenendIds || tenendIds.length === 0 ? 0 : tenendIds.split(',')[0]

              Vue.ls.set(TENANT_ID, tenendId, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TENANT', tenendId)

              dispatch('getTenantIdData')

              const userIdentitys = userInfo.userIdentity.split(',')
              Vue.ls.set(IDENTITY_ID, userIdentitys[0], 7 * 24 * 60 * 60 * 1000)
              commit('SET_IDENTITY', userIdentitys[0])
              dispatch('getCurrGradeClass', { userIdentitys })
              if (userIdentitys.includes('20')) {
                Vue.ls.set('devOps', true, 7 * 24 * 60 * 60 * 1000)
              }
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    // 获取用户信息
    GetPermissionList({ commit }) {
      return new Promise((resolve, reject) => {
        let v_token = Vue.ls.get(ACCESS_TOKEN)
        let params = { token: v_token }
        queryPermissionsByUser(params)
          .then((response) => {
            const menuData = response.result.menu
            const authData = response.result.auth
            const allAuthData = response.result.allAuth

            commit('SET_CURRUSERACTIONAUTH', authData)

            if (!menuData.length) {
              notification['error']({
                message: '该用户没有页面菜单，请找管理员配置菜单',
                duration: 4,
              })
            }
            //Vue.ls.set(USER_AUTH,authData);
            sessionStorage.setItem(USER_AUTH, JSON.stringify(authData))
            sessionStorage.setItem(SYS_BUTTON_AUTH, JSON.stringify(allAuthData))
            if (menuData && menuData.length > 0) {
              //update--begin--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
              menuData.forEach((item, index) => {
                if (item['children']) {
                  let hasChildrenMenu = item['children'].filter((i) => {
                    return !i.hidden || i.hidden == false
                  })
                  if (hasChildrenMenu == null || hasChildrenMenu.length == 0) {
                    item['hidden'] = true
                  }
                }
              })
              //console.log(" menu show json ", menuData)
              //update--end--autor:qinfeng-----date:20200109------for：JEECG-63 一级菜单的子菜单全部是隐藏路由，则一级菜单不显示------
              commit('SET_PERMISSIONLIST', menuData)
              Vue.ls.set(USER_AUTH_MENU, menuData, 7 * 24 * 60 * 60 * 1000)
            } else {
              reject('getPermissionList: permissions must be a non-null array !')
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        let logoutToken = state.token
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONLIST', [])
        Vue.ls.remove(ACCESS_TOKEN)
        Vue.ls.remove(UI_CACHE_DB_DICT_DATA)
        Vue.ls.remove('devOps')
        // 清除所有项
        Vue.ls.clear()
        //console.log('logoutToken: '+ logoutToken)
        logout(logoutToken)
          .then(() => {
            //let sevice = "http://"+window.location.host+"/";
            //let serviceUrl = encodeURIComponent(sevice);
            //window.location.href = window._CONFIG['casPrefixUrl']+"/logout?service="+serviceUrl;
            resetRouter()
            resolve()
          })
          .catch(() => {
            resolve()
          })
      })
    },
    // 第三方登录
    ThirdLogin({ commit }, token) {
      return new Promise((resolve, reject) => {
        thirdLogin(token)
          .then((response) => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    async saveTenant({ commit, dispatch }, id) {
      Vue.ls.set(TENANT_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TENANT', id)
      const userIdentitys = Vue.ls.get(USER_INFO).userIdentity.split(',')
      if (!userIdentitys.length) {
        return
      }
      await dispatch('getTenantIdData')
      dispatch('getCurrGradeClass', { userIdentitys, isReload: true })
    },
    // 切换用户身份
    async saveCurrIdentity({ commit, dispatch }, id) {
      Vue.ls.set(IDENTITY_ID, id, 7 * 24 * 60 * 60 * 1000)
      commit('SET_IDENTITY', id)
      await dispatch('getCurrGradeClass', { userIdentitys: [id], isReload: true })
    },
    // 切换用户登录
    ChangeUser({ commit, dispatch }, userId) {
      return new Promise((resolve, reject) => {
        changeUser({ userId: userId })
          .then(async (response) => {
            if (response.code == '200') {
              const result = response.result
              const userInfo = result.userInfo
              Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
              Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TOKEN', result.token)
              commit('SET_INFO', userInfo)
              commit('SET_NAME', {
                username: userInfo.username,
                realname: userInfo.realname,
                welcome: welcome(),
              })
              commit('SET_AVATAR', userInfo.avatar)
              console.log(userInfo)
              var tenendIds = userInfo.relTenantIds
              console.log(tenendIds)
              var tenendId = !tenendIds || tenendIds.length === 0 ? 0 : tenendIds.split(',')[0]

              Vue.ls.set(TENANT_ID, tenendId, 7 * 24 * 60 * 60 * 1000)
              commit('SET_TENANT', tenendId)

              const userIdentitys = userInfo.userIdentity.split(',')
              console.log('当前用户身份', userIdentitys)

              await dispatch('getTenantIdData')

              Vue.ls.set(IDENTITY_ID, userIdentitys[0], 7 * 24 * 60 * 60 * 1000)
              commit('SET_IDENTITY', userIdentitys[0])
              await dispatch('getCurrGradeClass', { userIdentitys })
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}

export default user
